import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/track-pre-check-form-progress`, data)

    return result.data
}

export default service
